<template>
    <div>

        <div class="TQ_padding_4px TQ_grid_col_Auto1frAuto TQ_bg_purple_lite TQ_borderRadius_top TQ_border">
            <img class="TQ_width_20px TQ_grid_verticalCenter TQ_clickable" @click="preMonth" :src="co_prevArrow_r" v-if="co_displayBackBtn_b"> <div v-else></div>
            <div class="TQ_text_24px TQ_grid_verticalCenter TQ_center"> {{monthNames[currentMonth][ps_system_langCode_s]}} {{currentYear}} </div>
            <img class="TQ_width_20px TQ_grid_verticalCenter TQ_clickable" @click="nextMonth" :src="co_nextArrow_r" v-if="co_displayNextBtn_b"><div v-else></div>
        </div>

        <div class="body">

            <!-- title  -->
            <div class="dayContainer"
                 v-for="day in optionsDays">
                <div class="day daysName TQ_bg_purple_lite TQ_textColor_white">
                    {{day[ps_system_langCode_s]}}
                </div>
            </div>

            <!-- body -->
            <div  class="dayContainer TQ_verticalAlignMiddle "
                  v-for="day_d in month">
                <div  class="day"
                      :class="{
                          'selectable'      : m_clickableDay_fb(day_d),
                          'selected'        : dayWithPurpleBg_b(day_d),
                          'today'           : today_b(day_d),
                      }"
                      @click="clickDay(day_d)">

                    <div v-if="m_inDisplayMonth_fb(day_d)"
                         class="TQ_width_20px TQ_center"
                         :class="{'TQ_slantedLine'  : !m_clickableDay_fb(day_d)}">
                        {{day_d.getDate()}}
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {format_date_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {
        date_getToday0am_d,
        date_getNowDate_resetSeconds_fd,
        date_sameDay_fb,
        date_newDate_fd
    } from "../../scripts/S_Date";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        ass_img_arrow_left_w,
        ass_img_arrow_right_w
    } from "../../assets/scripts/Ass_Files";
    import {helper_getDirectionByLangCode_fe} from "../../scripts/S_Helper";
    import {enum_directions} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "TqCalendarSmall",
        props:{

            ps_system_langCode_s:{
                require:true,
                type: String
            },

            pb_clickableMouthDays_an:{
                type: Array,
                default() {return []}
            },
            pb_purpleBgDays_ad:{
                type: Array,
                default() {return []}
            },

            pb_backMonths_n :{
                type    : Number,
                require : true
            },
            pb_forwardMonth_n: {
                type    : Number,
                require : true
            },

            pe_onClickDay_f: {
                type: Function,
                require: true
            },
            pe_changeMonth_f: {
                type: Function,
                require: true
            },



        },
        data(){
            return{
                currentYear: null,
                currentMonth: null,
                selectedDay: null,
                month :[],
                date: date_getNowDate_resetSeconds_fd(),

                // imports
                ass_strings : ass_strings,
                optionsDays : [ass_strings.oneWord_Sun, ass_strings.oneWord_Mon, ass_strings.oneWord_Tue,ass_strings.oneWord_Wed,ass_strings.oneWord_Thu,ass_strings.oneWord_Fri, ass_strings.oneWord_Sat],
                monthNames  : [
                    ass_strings.oneWord_January, ass_strings.oneWord_February, ass_strings.oneWord_March, ass_strings.oneWord_April, ass_strings.oneWord_May,
                    ass_strings.oneWord_June, ass_strings.oneWord_July, ass_strings.oneWord_August, ass_strings.oneWord_September, ass_strings.oneWord_October,
                    ass_strings.oneWord_November, ass_strings.oneWord_December,
                ],
            }
        },
        computed:{
            co_nextArrow_r(){

                return helper_getDirectionByLangCode_fe(this.ps_system_langCode_s) === enum_directions.ltr
                    ? ass_img_arrow_right_w : ass_img_arrow_left_w
            },
            co_prevArrow_r(){
                return helper_getDirectionByLangCode_fe(this.ps_system_langCode_s) === enum_directions.ltr
                    ? ass_img_arrow_left_w  : ass_img_arrow_right_w
            },

            co_displayBackBtn_b(){

                let now_d = date_getNowDate_resetSeconds_fd()
                now_d.setMonth(now_d.getMonth() - this.pb_backMonths_n)

                return this.currentYear > now_d.getFullYear() ||  this.currentMonth > now_d.getMonth()
            },
            co_displayNextBtn_b(){

                let now_d = date_getNowDate_resetSeconds_fd()
                now_d.setMonth(now_d.getMonth() + this.pb_forwardMonth_n)

                return this.currentYear < now_d.getFullYear() ||  this.currentMonth < now_d.getMonth()
            }


        },
        methods:{



            nextMonth(){
                let currentDisplayMonth_d = new Date(this.currentYear,this.currentMonth +1, 1)

                this.pe_changeMonth_f(currentDisplayMonth_d)
                this.setMouth(currentDisplayMonth_d)
            },
            preMonth(){
                let currentDisplayMonth_d = new Date(this.currentYear,this.currentMonth -1, 1)

                this.pe_changeMonth_f(currentDisplayMonth_d)
                this.setMouth(currentDisplayMonth_d)
            },
            clickDay(day_d){

                if(this.m_clickableDay_fb(day_d) && this.pe_onClickDay_f){
                    this.pe_onClickDay_f(day_d)
                }
            },

            // dom
            setMouth(newDate){
                this.month = []
                this.currentMonth = newDate.getMonth()
                this.currentYear = newDate.getFullYear()

                let temp = new Date(this.currentYear,this.currentMonth, 1 - newDate.getDay());

                // add preMonth days
                while(temp.getMonth() !==  this.currentMonth){

                    this.month.push(temp)
                    temp = date_newDate_fd(temp.getTime())
                    temp.setDate(temp.getDate() + 1);
                }

                // add thisMonth days
                while(temp.getMonth() ===  this.currentMonth){
                    this.month.push(temp)
                    temp = date_newDate_fd(temp.getTime())
                    temp.setDate(temp.getDate() + 1);
                }

                // add nextMonth days
                while(temp.getDay() !== 0){
                    this.month.push(temp)
                    temp = date_newDate_fd(temp.getTime())
                    temp.setDate(temp.getDate() + 1);
                }


            },


            m_clickableDay_fb(day_d){

                let today0am_d = date_getToday0am_d()

                if( this.currentMonth !== day_d.getMonth() ||
                    day_d.getTime() < today0am_d){
                    return false
                }


                return this.pb_clickableMouthDays_an.includes(day_d.getDate())

            },
            today_b(day_d){
                let now = date_getNowDate_resetSeconds_fd()
                return date_sameDay_fb(day_d, now)
            },
            dayWithPurpleBg_b(day_d){
                let ans = false
                this.pb_purpleBgDays_ad.forEach(date_d =>{
                    if(date_sameDay_fb(date_d, day_d))
                        ans = true
                })
                return ans
            },
            m_inDisplayMonth_fb(day_d){
                return this.currentMonth == day_d.getMonth()
            },

            SDate_sameDay_i: date_sameDay_fb,
            formatDateHour_i: format_date_hh_mm_fs
        },

        created(){
            let currentDisplayMonth_d = date_getNowDate_resetSeconds_fd()
            currentDisplayMonth_d.setDate(1)

            this.pe_changeMonth_f(currentDisplayMonth_d)
            this.setMouth(currentDisplayMonth_d)
        },
        activated(){
            let currentDisplayMonth_d = date_getNowDate_resetSeconds_fd()
            currentDisplayMonth_d.setDate(1)

            this.pe_changeMonth_f(currentDisplayMonth_d)
            this.setMouth(currentDisplayMonth_d)
        }

    }
</script>

<style scoped lang="scss">



    .body{

            min-width: 250px;

            &.big{
                min-width: 600px;
            }

            .dayContainer{
                width:calc(100% / 7);
                display:inline-block;
                color: gray;

                .day{
                    height: 16px;
                    padding:4px;
                    border: 1px solid #000;
                    text-align: center;
                    display: grid;

                    &.daysName{
                        font-weight: bold;
                    }

                    &.today{
                        background: var(--color-gray2);

                    }


                    &.selectable{
                        background-color:var(--color-green);;
                        cursor: pointer;
                        color: #000;
                        &:hover{
                            background-color: var(--color-gold);
                        }
                    }

                    &.selected{
                        background-color: #501078;
                        background-color: var(--color-purple);
                        color : white;
                    }

                }
            }

        }



</style>
